var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8368 0L7.51355 15.0242L9.17706 15.6042L14.5003 0.579979L12.8368 0ZM4.32514 2.66514L0.47133 7.23592L0 7.80209L0.47133 8.36826L4.32514 12.9529L5.69754 11.8205L2.31506 7.80209L5.68368 3.79748L4.32514 2.66514ZM17.6887 2.66514L16.3302 3.79748L19.6988 7.80209L16.3302 11.8067L17.7026 12.939L21.5287 8.36826L22 7.80209L21.5287 7.23592L17.6887 2.66514Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorCode);
export default __webpack_public_path__ + "static/media/icon_editor_code.c331b0fb6a07ac49a0e0c710e779208a.svg";
export { ForwardRef as ReactComponent };